import useDealer from "hooks/useDealer";
import DealerScripts from "views/Dealers/Tabs/DealerScripts";

// core components
import PageLayout from "layouts/PageLayout";

import { EDIT } from "const";

export default function DealerScriptsView({ ...otherProps }) {
    const dealer = useDealer();

    return (
        <PageLayout {...otherProps}>
            <DealerScripts dlid={dealer.id} form={EDIT} />
        </PageLayout>
    );
}
